<template>
  <div class="policy__wrapper">
    <ag-loading v-if="loading" />

    <div v-if="policyReview && !loading">
      <div
        class="policy"
        v-for="(company, key) in policyReview.companies"
        :key="key"
      >
        <div class="policy__header" @click.stop="togglePolicy($event)">
          <i
            class="
              policy__header__arrow policy__header__arrow--active
              ag-icon ag-icon_greyRightArrow
            "
          ></i>
          <span class="policy__header__title">{{ company.companyName }}</span>

          <div
            class="
              policy__header__statistics__box
              policy__header__statistics__box_total_computer
            "
            @click.stop="stopToggle"
          ></div>

          <div
            class="
              policy__header__statistics__box
              policy__header__statistics__box_version
            "
            @click.stop="stopToggle"
          ></div>
          <div
            class="
              policy__header__statistics__box
              policy__header__statistics__box_unqieblocks
            "
            @click.stop="stopToggle"
          ></div>
          <div
            class="
              policy__header__statistics__box
              policy__header__statistics__box_drafts
            "
            @click.stop="stopToggle"
          ></div>
          <div
            class="
              policy__header__statistics__box
              policy__header__statistics__box_applieds
            "
            @click.stop="stopToggle"
          ></div>
          <div
            class="
              policy__header__statistics__box
              policy__header__statistics__box_published
            "
            @click.stop="stopToggle"
          ></div>
          <div
            class="
              policy__header__statistics__box
              policy__header__statistics__box_keepenforcing
            "
            @click.stop="stopToggle"
          ></div>
          <div
            class="
              policy__header__statistics__box
              policy__header__statistics__box_mode
            "
            @click.stop="stopToggle"
          ></div>
          <div
            class="
              policy__header__statistics__box
              policy__header__statistics__box_status
            "
            @click.stop="stopToggle"
          ></div>
          <div
            class="
              policy__header__statistics__box
              policy__header__statistics__box_manage
            "
            @click.stop="stopToggle"
          ></div>
          <div
            class="
              policy__header__statistics__box
              policy__header__statistics__box_edit
            "
            @click.stop="stopToggle"
          ></div>
        </div>
        <div class="policy__body policy__body--active" v-if="company.sites">
          <div class="policy" v-for="(site, skey) in company.sites" :key="skey">
            <div class="policy__header" @click.stop="togglePolicy($event)">
              <i
                class="
                  policy__header__arrow policy__header__arrow--active
                  ag-icon ag-icon_greyRightArrow
                "
              ></i>
              <span class="policy__header__title">{{ site.siteName }}</span>
              <div class="policy__header__statistics__box"></div>
              <div
                class="
                  policy__header__statistics__box
                  policy__header__statistics__box--last
                "
              ></div>
              <div class="policy__header__gap"></div>
            </div>
            <div class="policy__body policy__body--active">
              <div class="policy__body__wrapper">
                <div
                  class="policy__body__row"
                  v-for="(group, gkey) in site.groups"
                  :key="gkey"
                >
                  <div class="policy__body__row__info">
                    <span>{{ group.groupName }}</span>
                  </div>

                  <div
                    class="policy__body__row__statistics stats-total_computer"
                  >
                    {{ group.totalComputers }}
                  </div>
                  <div class="policy__body__row__statistics stats-version">
                    <i class="policy__body__row__info__policy">
                      <span v-if="group.policyVersion">V {{ group.policyVersion / 10 }}</span>
                      <span v-else>N/A</span>
                    </i>
                  </div>

                  <div
                    class="policy__body__row__statistics stats-unqieblocks link"
                    @click="
                      changeScope(
                        company,
                        site,
                        group,
                        '/administration/policy-review'
                      )
                    "
                  >
                    {{ group.uniqueBlocks }}
                  </div>
                  <div
                    class="policy__body__row__statistics stats-drafts link"
                    @click="
                      changeScope(company, site, group, '/administration/policy-review/drafted')
                    "
                  >
                    {{ group.drafts }}
                  </div>
                  <div
                    class="policy__body__row__statistics stats-applieds link"
                    @click="
                      changeScope(
                        company,
                        site,
                        group,
                        '/administration/policy-review/applied'
                      )
                    "
                  >
                    {{ group.applied }}
                  </div>

                  <div
                    class="policy__body__row__statistics stats-published link"
                    @click="
                      changeScope(
                        company,
                        site,
                        group,
                        '/administration/policy-review/published'
                      )
                    "
                  >
                    {{ group.published }}
                  </div>

                  <div
                    class="
                      policy__body__row__statistics
                      stats-keepenforcing
                      link
                    "
                    @click="
                      changeScope(
                        company,
                        site,
                        group,
                        '/administration/policy-review/keep-enforcing'
                      )
                    "
                  >
                    {{ group.keepEnforcing }}
                  </div>

                  <div class="policy__body__row__statistics stats-mode">{{group.mode}}</div>

                  <div
                    class="policy__body__row__statistics stats-status"
                  >
                    <div
                      class="ready-to-enforce"
                      v-if="isReadyToEnforce(group)"
                    >
                      <strong>&#10003;</strong> {{$t("readytoEnforce")}}
                    </div>
                    <div class="needs-troubleshooting" v-else>
                      <strong>&#33;</strong> {{$t("NeedsTroubleshooting")}}
                    </div>
                  </div>

                  <div class="policy__body__row__statistics stats-manage link">
                    <div
                      @click="
                        changeScope(
                          company,
                          site,
                          group,
                          '/administration/group-dashboard'
                        )
                      "
                      class="ag-table-button"
                    >
                      {{$t("Manage")}}
                    </div>
                  </div>

                  <div class="policy__body__row__statistics stats-edit link">
                    <div
                      @click="
                        changeScope(
                          company,
                          site,
                          group,
                          '/administration/policy-tuning'
                        )
                      "
                      class="ag-table-button"
                    >
                      {{$t("editPolicy")}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <iframe
      :src="agmsUrlCompanyForSiteGroup"
      @load="onLoadIframeForSiteGroup"
      frameborder="0"
      width="0px"
      height="0px"
      v-if="agmsUrlCompanyForSiteGroup"
    ></iframe>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import api from "@/api/index";
import AgLoading from "@/components/ag-loading/index.vue";
import { Roles } from "@/helpers/enums/Roles";
import { mapState, mapActions, mapGetters } from "vuex";
import { GeneralActionTypes } from "@/store/modules/general/action-types";
import { AuthActionTypes } from "@/store/modules/auth/action-types";
import moment from "moment";
export default defineComponent({
  name: "PolicyReview",
  data() {
    return {
      policyReview: [],
      loading: true,
      groups: [],
      agmsUrlCompanyForSiteGroup: null,
      loadCount: 0,
      selectedUrl: ''
    };
  },
  computed: {
    ...mapGetters(["loggedInUser", "mainUser"]),
  },
  methods: {
    ...mapActions({
      setCompany: AuthActionTypes.SET_COMPANY,
      setUser: AuthActionTypes.SET_USER,
      setBreadcrumbData: GeneralActionTypes.SET_AGMS_BREADCRUMB_DATA,
      setBreadcrumbStatus: GeneralActionTypes.SET_AGMS_BREADCRUMB_STATUS,
      setSite: AuthActionTypes.SET_SITE,
      setGroup: AuthActionTypes.SET_GROUP,
      getSections: GeneralActionTypes.GET_SECTIONS,
    }),
    isReadyToEnforce(group) {
      let result = true;
      let sum1 = group.uniqueBlocks + group.drafts;
      let sum2 = group.published;
      let ratio = 0;
      if (sum2 > 0) {
        ratio = (sum1 * 100) / sum2;
      }
      result = ratio >= 60;
      return result;
    },
    stopToggle() {
      return false;
    },
    changeScope(company, site, group, url) {
      if (this.loggedInUser.role === Roles.GroupAdmin) {
        this.$router.push({ path: url });
      } else {
        this.selectedUrl = url;
        this.changeGroup(company, site, group);
      }
    },
    changeGroup(company, site, group) {
      if (this.changeRole(Roles.GroupAdmin)) {
        this.clearSiteAndGroup();
        const groupData = {
          key: group.groupGuid,
          value: group.groupName,
          mainid: group.mainId,
        };

        const siteData = {
          key: site.siteGuid,
          value: site.siteName,
          mainid: site.siteGuid,
        };

        const companyData = {
          companyGuid: company.companyGuid,
          companyId: company.companyGuid,
          companyName: company.companyName,
        };

        localStorage.setItem("company", JSON.stringify(companyData));
        localStorage.setItem("site", JSON.stringify(siteData));
        localStorage.setItem("group", JSON.stringify(groupData));
        this.setSite(siteData);
        this.setGroup(groupData);
        this.setCompany(companyData);
        this.agmsUrlCompanyForSiteGroup =
          process.env.VUE_APP_AGMS_URL +
          `/MultiTenant/ManageCompany/AGMSDashboard?companyId=${company.companyGuid.replaceAll('_', '-')}`;
      }
    },
    onLoadIframeForSiteGroup() {
      if (this.loadCount === 0) {
        const url = this.agmsUrlCompanyForSiteGroup;
        this.agmsUrlCompanyForSiteGroup = null;
        ++this.loadCount;
        this.agmsUrlCompanyForSiteGroup = url;
      }
      setTimeout(() => {
        this.$router.push({ path: this.selectedUrl });
      }, 1000);
    },
    changeRole(role) {
      let tempUser = this.mainUser;
      const roleIndex = tempUser.findIndex((i) => i.type === "role");
      localStorage.setItem("scopeChange", true);
      localStorage.setItem("selectedRole", role);
      localStorage.setItem('changingScope', true);
      if (roleIndex > -1) {
        tempUser[roleIndex].value = role;
        this.setUser(tempUser);
        this.loading = true;
        return true;
      }
      return false;
    },
    clearSiteAndGroup() {
      this.setBreadcrumbData({});
      this.setBreadcrumbStatus(false);
      localStorage.setItem("site", JSON.stringify({}));
      localStorage.setItem("group", JSON.stringify({}));
      this.setSite({});
      this.setGroup({});
    },
    togglePolicy(event) {
      let elem =
        event.currentTarget.parentElement.querySelector(".policy__body");
      let arrow = event.currentTarget.parentElement.querySelector(
        ".policy__header__arrow"
      );

      elem.classList.contains("policy__body--active")
        ? elem.classList.remove("policy__body--active")
        : elem.classList.add("policy__body--active");
      arrow.classList.contains("policy__header__arrow--active")
        ? arrow.classList.remove("policy__header__arrow--active")
        : arrow.classList.add("policy__header__arrow--active");
    },
  },
  async created() {
    let pStartDate = moment().startOf("day").subtract(7, "days").utc().format("YYYY-MM-DDTHH:mm:ss.SSS");
    let pEndDate = moment().utc().format("YYYY-MM-DDTHH:mm:ss.SSS");
    let polPayload = {
      startDate: pStartDate,
      endDate: pEndDate,
    };
    const res = await api.policyReview.getPolicyReviewDashboard(polPayload);
    this.policyReview = res.data.entityData;
    const resGroup = await api.groups.get();
    this.groups = resGroup.data.entityData;
    this.loading = false;
  },
  components: { AgLoading },
});
</script>

<style lang="scss" scoped>
.ready-to-enforce {
  color: #799d02;
}
.needs-troubleshooting {
  color: #bf3100;
}
.policy__wrapper {
  padding-bottom: 40px;
  background-color: #fafafa;
}

.policy {
  background-color: #fafafa;
  border-top: 3px solid #d8dfe3;
  padding-top: 55px;
  position: relative;

  .stats-total_computer {
    width: 80px !important;
    padding-left: 30px;
  }

  .stats-version {
    width: 80px !important;
    padding-left: 30px;
  }

  .stats-unqieblocks {
    width: 60px !important;
    padding-left: 30px;
  }

  .stats-drafts {
    width: 60px !important;
    padding-left: 30px;
  }

  .stats-applieds {
    width: 80px !important;
    padding-left: 30px;
  }

  .stats-published {
    width: 80px !important;
    padding-left: 30px;
  }

  .stats-keepenforcing {
    width: 60px !important;
    padding-left: 15px;
  }
  .stats-mode {
    width: 60px !important;
    font-size: 12px !important;
  }
  .stats-status {
    width: 190px !important;
    font-size: 12px !important;
  }
  .stats-manage {
    width: 100px !important;
    font-size: 12px !important;
  }
  .stats-edit {
    width: 120px !important;
    font-size: 12px !important;
  }

  &:before {
    content: "";
    background: #d8dfe3;
    width: 3px;
    height: calc(100% - 142px);
    margin-left: 28px;
    position: absolute;
    top: 142px;
  }

  &__header {
    display: flex;
    color: #4c8dbb;
    background-color: #fafafa;
    font-size: 14px;
    border: solid #d8dfe3;
    border-width: 1px 0 3px 0;
    align-items: center;
    cursor: pointer;
    padding: 6px 0;
    background: #f4f4f4;

    &__arrow {
      height: 18px;
      padding: 0 25px;
      transform: rotate(90deg);
      transition: 0.5s cubic-bezier(0, 1, 0, 1);

      &--active {
        transform: rotate(-90deg);
      }
    }

    &__title {
      flex-grow: 2;
      max-width: 40vw;
    }

    &__statistics__box_version {
      &:before {
        content: "Policy Version" !important;
        border-left: 1px solid #d8dfe3;
        width: 80px;
        height: 100%;
        position: absolute;
        top: 0;
        z-index: 99;
        text-align: center;
        font-size: 12px;
        font-weight: bold;
        color: #000;
        line-height: 16px;
        padding-top: 12px;
      }
    }

    &__statistics__box_total_computer {
      &:before {
        content: "Endpoint Host Name" !important;
        border-left: 1px solid #d8dfe3;
        width: 80px;
        height: 100%;
        position: absolute;
        top: 0;
        z-index: 99;
        text-align: center;
        font-size: 12px;
        font-weight: bold;
        color: #000;
        line-height: 16px;
        padding-top: 12px;
      }
    }

    &__statistics__box_unqieblocks {
      &:before {
        content: "Reviews" !important;
        border-left: 1px solid #d8dfe3;
        width: 60px;
        height: 100%;
        position: absolute;
        top: 0;
        z-index: 99;
        text-align: center;
        font-size: 12px;
        font-weight: bold;
        color: #000;
        line-height: 16px;
        padding-top: 12px;
      }
    }

    &__statistics__box_drafts {
      &:before {
        content: "Drafts" !important;
        border-left: 1px solid #d8dfe3;
        width: 60px;
        height: 100%;
        position: absolute;
        top: 0;
        z-index: 99;
        text-align: center;
        font-size: 12px;
        font-weight: bold;
        color: #000;
        line-height: 16px;
        padding-top: 12px;
      }
    }

    &__statistics__box_applieds {
      &:before {
        content: "Applied" !important;
        border-left: 1px solid #d8dfe3;
        width: 80px;
        height: 100%;
        position: absolute;
        top: 0;
        z-index: 99;
        text-align: center;
        font-size: 12px;
        font-weight: bold;
        color: #000;
        line-height: 16px;
        padding-top: 12px;
      }
    }

    &__statistics__box_published {
      &:before {
        content: "Published" !important;
        border-left: 1px solid #d8dfe3;
        width: 70px;
        height: 100%;
        position: absolute;
        top: 0;
        z-index: 99;
        text-align: center;
        font-size: 12px;
        font-weight: bold;
        color: #000;
        line-height: 16px;
        padding-top: 12px;
      }
    }

    &__statistics__box_keepenforcing {
      &:before {
        content: "Keep Enforcing" !important;
        border-left: 1px solid #d8dfe3;
        width: 60px;
        height: 100%;
        position: absolute;
        top: 0;
        z-index: 99;
        text-align: center;
        font-size: 12px;
        font-weight: bold;
        color: #000;
        line-height: 16px;
        padding-top: 12px;
      }
    }
    &__statistics__box_mode {
      &:before {
        content: "Mode" !important;
        border-left: 1px solid #d8dfe3;
        width: 60px;
        height: 100%;
        position: absolute;
        top: 0;
        z-index: 99;
        text-align: center;
        font-size: 12px;
        font-weight: bold;
        color: #000;
        line-height: 16px;
        padding-top: 12px;
      }
    }
    &__statistics__box_status {
      &:before {
        content: "Status" !important;
        border-left: 1px solid #d8dfe3;
        width: 190px;
        height: 100%;
        position: absolute;
        top: 0;
        z-index: 99;
        text-align: center;
        font-size: 12px;
        font-weight: bold;
        color: #000;
        line-height: 16px;
        padding-top: 12px;
      }
    }
    &__statistics__box_manage {
      &:before {
        content: "Manage" !important;
        border-left: 1px solid #d8dfe3;
        width: 100px;
        height: 100%;
        position: absolute;
        top: 0;
        z-index: 99;
        text-align: center;
        font-size: 12px;
        font-weight: bold;
        color: #000;
        line-height: 16px;
        padding-top: 12px;
      }
    }
    &__statistics__box_edit {
      &:before {
        content: "Edit" !important;
        border-left: 1px solid #d8dfe3;
        width: 120px;
        height: 100%;
        position: absolute;
        top: 0;
        z-index: 99;
        text-align: center;
        font-size: 12px;
        font-weight: bold;
        color: #000;
        line-height: 16px;
        padding-top: 12px;
      }
    }

    &__statistics__box_version {
      width: 80px;
      font-size: 14px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    &__statistics__box_total_computer {
      width: 80px;
      font-size: 14px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    &__statistics__box_unqieblocks {
      width: 60px;
      font-size: 14px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    &__statistics__box_drafts {
      width: 60px;
      font-size: 14px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    &__statistics__box_applieds {
      width: 80px;
      font-size: 14px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    &__statistics__box_published {
      width: 70px;
      font-size: 14px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    &__statistics__box_keepenforcing {
      width: 60px;
      font-size: 14px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    &__statistics__box_mode {
      width: 60px;
      font-size: 14px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    &__statistics__box_status {
      width: 190px;
      font-size: 14px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    &__statistics__box_manage {
      width: 100px;
      font-size: 14px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    &__statistics__box_edit {
      width: 120px;
      font-size: 14px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    &__gap {
      flex-grow: 1;
    }
  }

  &__body {
    overflow: hidden;
    max-height: 0;
    transition: 0.3s ease-in-out;
    padding-bottom: 0;

    &--active {
      max-height: 4000px;
      transition: max-height 0.3s ease-in-out;
    }
  }

  & &__body {
    .policy {
      padding-top: 0;
      border-top: 0;
      background-color: transparent;
      position: static;

      &__header {
        background-color: transparent;
        padding-left: 55px;
        border: none;
        position: relative;
        padding-top: 42px;
        padding-bottom: 30px;

        &:before {
          content: unset;
          display: none;
        }

        &__title {
          max-width: calc(40vw - 100px);

          &:before {
            content: "";
            background-color: #d8dfe3;
            position: absolute;
            display: block;
            width: 15px;
            height: 3px;
            left: 28px;
            margin-top: 9px;
          }
        }

        &__arrow {
          height: 16px;
        }

        &:after {
          content: "Site";
          width: auto;
          left: 47px;
          top: 45px;
          font-size: 11px;
          color: #b7c6cd;
          position: absolute;
        }

        &__statistics__box {
          &:before,
          &:after {
            content: unset;
            display: none;
          }
        }
      }

      &__body {
        padding-left: 50px;
        position: relative;

        &__wrapper {
          border: 2px solid #d8dfe3;
        }

        &:before {
          content: "";
          background: #d8dfe3;
          width: 3px;
          height: calc(100% - 20px);
          margin-left: 28px;
          position: absolute;
          top: 0;
          z-index: 99;
        }

        &__row {
          background-color: #f4f4f4;
          padding: 5px 0px;
          border: solid #d8dfe3;
          border-width: 0 0 1px 0;
          display: flex;
          align-items: center;
          position: relative;

          &:last-child {
            border-width: 0;
          }

          &__info {
            color: #4c8dbb;
            font-size: 16px;
            max-width: 180px;
            max-width: calc(40vw - 42px);
            display: flex;
            align-items: center;
            flex-grow: 1;
            // padding-right: 130px;

            padding-left: 76px;
            position: relative;
            padding-top: 2px;

            span {
              color: #666 !important;
              padding-left: 16px;
            }

            .pointer {
              cursor: pointer;
            }

            &:before {
              content: "Group";
              width: auto;
              left: 33px;
              top: 5px;
              font-size: 13px;
              color: #b7c6cd;
              position: absolute;
              font-weight: 400;
            }

            & span {
              flex-grow: 1;

              &:before {
                content: "";
                background-color: #d8dfe3;
                position: absolute;
                display: block;
                width: 12px;
                height: 3px;
                left: 75px;
                margin-top: 12px;
              }
            }

            &__overview,
            &__policy {
              padding: 0 15px;
              // border: solid rgba(112, 112, 112, 0.27);
              text-align: center;
              font-size: 13px;
            }

            &__overview {
              border-width: 0 0 0 1px;
              padding-right: 0;
              font-style: normal;
            }

            &__policy {
              font-style: normal;
              border-width: 0 0 0 1px;
            }
          }
          &__statistics {
            font-size: 14px;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #000;
            z-index: 999;
          }
          &__statistics.link {
            font-size: 14px;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #4c8dbb;
            cursor: pointer;
            z-index: 999;
          }
        }
      }
    }
  }
}
</style>
